import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import documentConstantsFactory from '../../constants/documentConstantsFactory';
import detailActionFactory from './detailActionFactory';
import entityActionFactory from './entityActionFactory';
import changeActionFactory from './changeActionFactory';
import uploadActionFactory from './uploadActionFactory';
import tokenErrorActionCreators from '../tokenErrorActionCreators';
import * as ajax from '../ajax';
const documentActionFactory = entity => {
  // define the basic actions, and include page and change actions.
  const detailActions = detailActionFactory(entity, 'library');
  const entityActions = entityActionFactory(entity, 'library');
  const changeActions = changeActionFactory(entity, 'library');
  const uploadActions = uploadActionFactory(entity, 'library', true, 'PDF');
  const documentConstants = documentConstantsFactory(entity);
  const includedActions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, entityActions), detailActions), changeActions), uploadActions);
  const documentActions = _objectSpread(_objectSpread({}, includedActions), {}, {
    setIsSelectingAssociations(selecting) {
      return {
        type: documentConstants.SELECTING_ASSOCIATIONS,
        selecting // bool - true shows modal
      };
    },
    serverDownload(formDocument) {
      return async dispatch => {
        const url = '/documents/render';
        try {
          const response = await ajax.post(url, {
            formDocument
          });
          if (response.data && response.data.pdfPath) {
            return dispatch(documentActions.downloadSuccess({
              renderedDocument: response.data,
              formDocument
            }));
          }
          return dispatch(documentActions.downloadFailure(formDocument));
        } catch (e) {
          return dispatch(tokenErrorActionCreators.handleError(e, 'document', documentActions.downloadFailure.bind(this, formDocument), documentActions.serverDownload.bind(this, formDocument)));
        }
      };
    },
    // set the pdfPath
    downloadSuccess(_ref) {
      let renderedDocument = _ref.renderedDocument,
        formDocument = _ref.formDocument;
      return {
        type: documentConstants.DOWNLOAD_SUCCESS,
        formDocument,
        renderedDocument
      };
    },
    // update error state
    downloadFailure(formDocument) {
      return {
        type: documentConstants.DOWNLOAD_FAILURE,
        formDocument
      };
    },
    downloadClear(active) {
      if (active) {
        return {
          type: documentConstants.CLEAR_DOWNLOAD
        };
      }
      return undefined;
    },
    /**
     *  Create a new batch (1 or more) of files then trigger a server upload
     *
     *  @param ids - array - list of objects where each key holds a unique uuid, used in
     *                       createNewEntityForFile to keep `create` pure
     *                       { id: uuid, cloudDocumentID: uuid, remotePath: uuid }
     *  @param createdDate - date - used for created date
     *  @param files - array - raw file entities passed back from the browser
     *  @param tags - array - pre selected tags
     *  @param jobs - array - pre selected jobs
     *  @param userID - string - currently logged in user
     */
    create(ids, createdDate, files, tags, jobs, userID) {
      // Create a new document entity (formatted for knex save - not bookshelf)
      const createNewEntityForFile = (file, index) => ({
        id: ids[index].id,
        hashString: ids[index].hashString,
        appCreatorID: userID,
        appCreated: createdDate,
        cloudDocumentID: ids[index].cloudDocumentID,
        byteSize: file.size,
        displayName: file.name,
        tags,
        jobs,
        isNew: true,
        // need this or else update will be tried instead of insert
        rawFile: file,
        remotePath: "".concat(ids[index].remotePath, ".pdf"),
        uploaded: false,
        type: file.type,
        savingToServer: false
      });
      const filesToUpload = files.map((nextFile, index) => createNewEntityForFile(nextFile, index));
      return dispatch => dispatch(documentActions.serverUpload(undefined, '', '', filesToUpload));
    },
    // set the pdfPath
    render(_ref2) {
      let formDocument = _ref2.formDocument;
      return {
        type: documentConstants.RENDER,
        formDocument
      };
    },
    serverRender(formDocument) {
      return async dispatch => {
        const url = '/documents/render';
        dispatch(documentActions.render({
          formDocument
        }));
        try {
          const response = await ajax.post(url, {
            formDocument
          });
          if (response.data && response.data.pdfPath) {
            return dispatch(documentActions.renderSuccess({
              renderedDocument: response.data,
              formDocument
            }));
          }
          return dispatch(documentActions.renderFailure(formDocument));
        } catch (e) {
          return dispatch(tokenErrorActionCreators.handleError(e, 'reportDocument', documentActions.renderFailure.bind(this, formDocument), documentActions.serverRender.bind(this, formDocument)));
        }
      };
    },
    // set the pdfPath
    renderSuccess(_ref3) {
      let renderedDocument = _ref3.renderedDocument,
        formDocument = _ref3.formDocument;
      return {
        type: documentConstants.RENDER_SUCCESS,
        formDocument,
        renderedDocument
      };
    },
    // update error state
    renderFailure(formDocument) {
      return {
        type: documentConstants.RENDER_FAILURE,
        formDocument
      };
    },
    // reset - clear pdfPath, error and reset annotaitons to an empty array
    reset() {
      return {
        type: documentConstants.RESET
      };
    }
  });
  return documentActions;
};
export default documentActionFactory;